// import { CaretDown } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import { translate } from '../Services/translation';

export default ({
  children,
  label,
  className = '',
  transitionDuration = '0.2s',
  onStateChange: externalStateChange,
  showTogglerText,
  isOpen: externalIsOpen,
  openLabel,
  closeLabel,
}) => {
  const [isOpen, setIsOpen] = useState(externalIsOpen ?? false);

  const onStateChange = (open) => {
    externalStateChange && externalStateChange(open);
    setIsOpen(open);
  };

  useEffect(() => {
    setIsOpen(externalIsOpen);
  }, [externalIsOpen]);

  return (
    <div className={'collapsible ' + className}>
      <label onClick={() => onStateChange(!isOpen)}>
        {label}
        <div className="collapsible__toggler-wrapper">
          {showTogglerText && (
            <span>
              {isOpen
                ? closeLabel ?? translate('collapsible.hide')
                : openLabel ?? translate('collapsible.show')}
            </span>
          )}
          <div
            className="ph-caret-down"
            size="14"
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
              transitionDuration: transitionDuration,
            }}
          ></div>
        </div>
      </label>
      <div className="collapsible__content">
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </div>
    </div>
  );
};
